<template>
  <div>
    <template v-if="item.computed_confirmation_type === 'support'">
      <a class="ivu-btn ivu-btn-info" href="https://t.me/Zorra_Support" target="_blank">{{ $t('phone-number.number.computed_confirmation_type.support') }}</a>
    </template>

    <template v-if="item.computed_confirmation_type === 'required_documents'">
      <i-button type="error" @click="required_documents(item)">
        {{ $t('phone-number.number.computed_confirmation_type.required_documents') }}
      </i-button>
    </template>

    <template v-else-if="item.computed_confirmation_type === 'need_verification'">
      <i-button type="warning">
        {{ $t('phone-number.number.computed_confirmation_type.need_verification') }}
      </i-button>
    </template>

    <!-- TODO: разобраться, что за статус -->
    <!-- <template v-else-if="item.computed_confirmation_type === 'document'">
      <i-button type="info">
        {{ $t('phone-number.number.computed_confirmation_type.document') }}
      </i-button>
    </template> -->

    <template v-else-if="item.computed_confirmation_type === 'allow_buying' || item.computed_confirmation_type === null">
      <i-button type="success" @click="buy(item)">
        {{ $t('phone-number.number.computed_confirmation_type.allow_buying') }}
      </i-button>
    </template>
  </div>
</template>

<script>
  import { NumberModalService } from '@phone-number/modals/NumberModalService';

  export default {
    props: {
      item: {
        type: Object,
        required: true
      }
    },

    methods: {
      required_documents: function (item) {
        NumberModalService.required_documents(item).on('success', () =>
          this.$router.push({
            name: 'core.document.create'
          })
        );
      },
      buy: function (item) {
        NumberModalService.buy(item.id, item);
      }
    }
  };
</script>
